import React from "react";
import { useSelector, useDispatch } from "react-redux";
import discountAction from "../../../redux/discounts/actions";
import { Select, Spin, notification } from "antd";

const { appendDiscounts, removeDiscounts } = discountAction;

const DiscountManagementDiscounts = ({ discountsArray = [], user }) => {
  const dispatch = useDispatch();
  const { allDiscounts } = useSelector((state) => state.discountReducer);

  const options = allDiscounts
    .filter(
      (discount) =>
        !discountsArray.find((d) => d.exportCodeName === discount.name)
    )
    .map((discount) => ({
      value: discount.name,
      label: discount.name,
    }));

  const defaultValue = discountsArray.map(
    (discount) => discount.exportCodeName
  );

  const onSelectChange = (value) => {
    if (discountsArray.length >= 1) {
      return notification["error"]({
        message: "Може да има само една активна отстъпка",
      });
    }
    const selectedDiscount = allDiscounts.find(
      (discount) => discount.name === value
    );

    const data = {
      userId: user.id,
      TouchSaleExportCode: selectedDiscount.exportCode,
      ExportCodeName: selectedDiscount.name,
      Percent: selectedDiscount.percent,
      OrganizationName: localStorage.getItem("organization"),
      ExportCodeMessage: selectedDiscount.info,
      OrganizationId: localStorage.getItem("organizationId"),
    };

    dispatch(appendDiscounts(data));
  };

  const onDeselectChange = (value) => {
    const selectedDiscount = allDiscounts.find(
      (discount) => discount.name === value
    );

    const data = {
      userId: user.id,
      TouchSaleExportCode: selectedDiscount.exportCode,
      OrganizationId: localStorage.getItem("organizationId"),
    };
    dispatch(removeDiscounts(data));
  };

  return (
    <Select
      mode="multiple"
      style={{
        width: "100%",
      }}
      notFoundContent={
        options.length === 0 ? (
          <Spin
            size="small"
            style={{ display: "flex", justifyContent: "center" }}
          />
        ) : null
      }
      placeholder="Избор на Отстъпка"
      onSelect={onSelectChange}
      onDeselect={onDeselectChange}
      options={options}
      value={defaultValue}
    />
  );
};

export default DiscountManagementDiscounts;
